const COMP_DRAFT_KEY = "mc_comp_draft";
export const RENTAL_COMP_DRAFT_KEY = "mc_rental_comp_draft";
const DRAFT_TTL_MS = 30 * 24 * 60 * 60 * 1000; // 30 days
const MAX_CONTENT_SIZE = 500 * 1024; // 500KB

function sanitizeCompSettings(compSettings) {
  if (!compSettings) return compSettings;
  const sanitized = { ...compSettings };
  // propertyDetails.property contains circular references from the API response
  if (sanitized.propertyDetails) {
    const { property, ...rest } = sanitized.propertyDetails;
    sanitized.propertyDetails = rest;
  }
  return sanitized;
}

// Circular-reference-safe JSON.stringify.  Uses an ancestor stack so that
// *shared* references (the same object reachable via two different paths) are
// serialized normally, while only true *circular* references (a descendant
// pointing back to an ancestor) are dropped.
function safeStringify(obj) {
  var ancestors = [];
  return JSON.stringify(obj, function (key, value) {
    if (typeof value !== 'object' || value === null) return value;

    // `this` is the holder – the object that contains the current key.
    // Pop the stack back until we find the holder so that siblings and
    // cousins don't keep growing the stack.
    while (ancestors.length > 0 && ancestors[ancestors.length - 1] !== this) {
      ancestors.pop();
    }

    // If value is already an ancestor we have a circular reference – skip it.
    if (ancestors.indexOf(value) !== -1) return undefined;

    ancestors.push(value);
    return value;
  });
}

export function saveCompDraft(data, key = COMP_DRAFT_KEY) {
  console.log(data)
  try {
    const draft = {
      ...data,
      compSettings: sanitizeCompSettings(data.compSettings),
      savedAt: Date.now(),
    };

    // Truncate editedContent if too large
    if (draft.editedContent && typeof draft.editedContent === 'string' && draft.editedContent.length > MAX_CONTENT_SIZE) {
      draft.editedContent = null;
      draft.editedContentTruncated = true;
    }

    const serialized = safeStringify(draft);
    localStorage.setItem(key, serialized);
    console.log("saveCompDraft saved successfully, size:", serialized.length);
  } catch (e) {
    console.error("Failed to save comp draft:", e);
  }
}

export function loadCompDraft(key = COMP_DRAFT_KEY) {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;

    const draft = JSON.parse(raw);

    // Check expiration
    if (draft.savedAt && Date.now() - draft.savedAt > DRAFT_TTL_MS) {
      deleteCompDraft(key);
      return null;
    }

    return draft;
  } catch (e) {
    console.warn("Failed to load comp draft:", e);
    return null;
  }
}

export function deleteCompDraft(key = COMP_DRAFT_KEY) {
  try {
    localStorage.removeItem(key);
  } catch (e) {
    console.warn("Failed to delete comp draft:", e);
  }
}

export function formatTimeAgo(timestamp) {
  if (!timestamp) return "";
  const seconds = Math.floor((Date.now() - timestamp) / 1000);

  if (seconds < 60) return "just now";
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return minutes + (minutes === 1 ? " minute ago" : " minutes ago");
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return hours + (hours === 1 ? " hour ago" : " hours ago");
  const days = Math.floor(hours / 24);
  return days + (days === 1 ? " day ago" : " days ago");
}
